const CategoryFixedIcon = () => (
  <svg viewBox='0 0 24 24' className='h-[22px] w-[22px]' aria-hidden>
    <rect
      x='3'
      y='3'
      width='7'
      height='7'
      rx='1.5'
      stroke='currentColor'
      strokeWidth='1.8'
      fill='none'
    />
    <rect
      x='14'
      y='3'
      width='7'
      height='7'
      rx='1.5'
      stroke='currentColor'
      strokeWidth='1.8'
      fill='none'
    />
    <rect
      x='3'
      y='14'
      width='7'
      height='7'
      rx='1.5'
      stroke='currentColor'
      strokeWidth='1.8'
      fill='none'
    />
    <rect
      x='14'
      y='14'
      width='7'
      height='7'
      rx='1.5'
      stroke='currentColor'
      strokeWidth='1.8'
      fill='none'
    />
  </svg>
);
export default CategoryFixedIcon;
